import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { formatNumber } from "../../components/Utils";
export function RangeFilter({ id, range, value, label, customClass, type, suffix, step, valueChanged, }) {
    const [rangeValue, setRangeValue] = useState(value);
    useEffect(() => {
        valueChanged?.(rangeValue);
    }, [rangeValue]);
    useEffect(() => {
        if (value === rangeValue) {
            return;
        }
        setRangeValue(value);
    }, [value]);
    return (_jsxs("div", { className: "car-filtr__range " + customClass, children: [_jsxs("label", { className: "car-filtr__label", htmlFor: id, children: [label, ":"] }), _jsx("div", { className: "car-filtr__range-wrap", children: _jsx("input", { className: "car-filtr__range-input", id: id, name: id, type: "range", min: range.min, max: range.max, multiple: true, value: rangeValue, onInput: ($event) => setRangeValue(Number($event.target.value)), step: step }) }), _jsx("div", { className: "car-filtr__range-desc", children: _jsxs("div", { children: [type === "max" ? (`do ${formatNumber(rangeValue)}`) : type === "min" ? (`od ${formatNumber(rangeValue)}`) : formatNumber(rangeValue), " ", suffix] }) })] }));
}
